module.exports = __webpack_public_path__ + "img/main.593b6d4a.svg";